import {
  BLOCK_BOOKING_OPTION,
  FREE_TRIAL,
  PAY_AS_YOU_GO_OPTION,
} from '../../common/config/constants';

export const CHILD = 'child';
export const ADULT = 'adult';
export const SIBLING = 'sibling';

const CHILD_OPTION = {
  key: CHILD,
  label: 'Child',
};
const ADULT_OPTION = {
  key: ADULT,
  label: 'Adult',
};
const SIBLING_OPTION = {
  key: SIBLING,
  label: 'Sibling',
};

export const TICKET_TYPES_OPTIONS = [CHILD_OPTION, SIBLING_OPTION, ADULT_OPTION];

export const TICKET_TYPES_WITH_SIBLING_DISABLED = [
  CHILD_OPTION,
  {
    key: SIBLING,
    label: 'Sibling',
    disabled: true,
  },
  ADULT_OPTION,
];

export const AGE_UNIT_OPTIONS = [
  {
    option: 'years',
    label: 'Years',
  },
  {
    option: 'months',
    label: 'Months',
  },
];

export const TICKET_SALES_CLOSE_OPTIONS = [
  {
    option: 'minutes',
    label: 'Minutes',
  },
  {
    option: 'hours',
    label: 'Hours',
  },
  { option: 'days', label: 'Days' },
];

export const PRICING_OPTIONS = [
  {
    key: PAY_AS_YOU_GO_OPTION,
    label: 'Pay as you go',
  },
  {
    key: BLOCK_BOOKING_OPTION,
    label: 'Block booking',
  },
];

export const TRIAL_OPTIONS = [
  {
    key: FREE_TRIAL,
    label: 'Free Trial',
  },
];

export const SESSION_CLOSE_OPTIONS = [
  {
    key: 'before',
    label: 'Before session starts',
  },
];

export const SESSION_CLOSE_OPTIONS_BEFORE = [
  {
    option: 'before',
    label: 'Before session starts',
  },
];

export const CUSTOM_SCHEDULE = 'custom-schedule';

export const MAX_CUSTOM_FAQS = 20;
export const CUSTOM_FAQS_FIELD_NAME = 'customFaqs';
export const MAX_FAQS_LENGTH = 1000;

export const ADDONS_FIELD_NAME = 'addons';
export const MAX_ADDONS = 5;
export const ADDON_MAX_NAME_LENGTH = 32;
export const ADDON_MAX_DESCRIPTION_LENGTH = 256;
export const ADDON_MAX_PRICE = 99.99;
